import i18next from 'i18next';
import { NoteFormData, NoteType } from './types';
import * as yup from 'yup';

export const defaultNoteData = {
  text: '',
  startDate: null,
  endDate: null,
  urgent: false,
  noteType: NoteType.OneDay,
};

const requiredMessage = () => i18next.t('translation:errors.required');

function t(value: string, options?: any) {
  return i18next.t(`translation:errors.${value}` as any, options);
}

export const noteYupSchema: yup.Schema<NoteFormData> = yup.object({
  noteType: yup.mixed<NoteType>().required(requiredMessage),
  text: yup
    .string()
    .trim()
    .required(requiredMessage)
    .max(1024, ({ max }) =>
      t('max_length', {
        maxLength: max,
      }),
    ),
  startDate: yup.date().when('noteType', {
    is: (noteType?: NoteType) => noteType === NoteType.NoDate,
    then: (schema) => schema.nullable(),
    otherwise: (schema) =>
      schema.required(requiredMessage).typeError(() => t('invalid_date')),
  }),
  endDate: yup.date().when('noteType', {
    is: (noteType?: NoteType) => noteType === NoteType.Period,
    then: (schema) =>
      schema.required(requiredMessage).typeError(() => t('invalid_date')),
    otherwise: (schema) => schema.nullable(),
  }),
  urgent: yup.boolean().defined(),
});
